import { FC } from "react";
import ServicePage from "./ServicePage";

const WatchServicePage: FC = () => (
  <ServicePage
    title="Gözlem Hizmeti"
    seoDescription="Securitas Gözcü Personelinin yangın emniyeti denetimleri ve anlık risk raporlaması ile tesis yangın emniyetini en üst seviyede koruyan Gözlem Hizmeti."
    intro={[
      "Eğitimleri tesis proses özelinde müşteri tarafından verilen Securitas Gözcü Personelinin gerçekleştirdiği yangın emniyeti denetimleri sayesinde daha hızlı ve güvenli bir hizmet verilir. Securitas Gözcü Personelinin yaptığı denetim ve kontroller sırasında tespit ettiği riskleri müşteri tarafına anlık olarak raporlaması sayesinde tesis yangın emniyeti en üst seviyede korunur.",
    ]}
    sections={[
      {
        icon: "grad",
        title: "Eğitim",
        paragraphs: [
          "Temel itfaiye eğitimlerini başarı ile bitiren personel, aynı zamanda mesleki yeterlilik eğitimlerini de başarı ile bitirmiş kişiler arasından seçilir. Tesis içerisinde yaptırılacak göreve özel eğitimler ile desteklenen personel, görev yeri talimatlarında belirtilen görevlerin yerine getirilmesi için alınması gereken yetkinlik eğitimlerini başarılı bir şekilde tamamlar.",
        ],
      },
      {
        icon: "tool",
        title: "Teçhizat ve Donanım",
        paragraphs: [
          "6331 Sayılı İş Sağlığı ve Güvenliği Kanunu kapsamında, koruyucu iş ekipmanlarıyla donatılan Gözcü personel, gerekli eğitimleri alır ve sorumluluk sahasında kullanacağı malzemelerle desteklenir.",
        ],
      },
    ]}
  />
);

export default WatchServicePage;
